import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-3column 30",
  "use": "icon-3column 30-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-3column 30\"><path d=\"M234.666667 853.333333a64 64 0 0 1-64-64V234.666667a64 64 0 0 1 64-64h554.666666a64 64 0 0 1 64 64v554.666666a64 64 0 0 1-64 64H234.666667z m138.666666-618.666666H234.666667v554.666666h138.666666V234.666667z m213.333334 0h-149.333334v554.666666h149.333334V234.666667z m202.666666 0h-138.666666v554.666666H789.333333V234.666667z\" p-id=\"8063\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol